import { makeStyles } from '@material-ui/styles'

export default makeStyles((theme) => ({
  item: {
    padding: theme.spacing(2),
  },
  subtitulo: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: 600,
  },
  carregandoAcessos: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  listaVazia: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 0),
  },
  listaUsuarios: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    maxHeight: 240,
    overflowX: 'hidden',
    overflowY: 'auto',
    scrollbarColor: `${theme.palette.grey[400]} transparent`,
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[400],
      borderRadius: 6,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.grey[500],
    },
  },
  usuarioComAcesso: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5),
    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
  },
  identificacaoUsuario: {
    minWidth: 0,
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  nomeUsuario: {
    color: theme.palette.text.primary,
    fontSize: '0.9rem',
    fontWeight: 500,
    overflowWrap: 'anywhere',
  },
  cargoUsuario: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  dataAcesso: {
    color: theme.palette.text.secondary,
    fontSize: '0.8rem',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(0.5),
    },
  },
}))
